import { defaultColumns, defaultSort } from '../../components/users/categories/columns';

export default {
  state: {
    userCategories: [],
    tableConfig: null,
    loading: false,
  },
  getters: {
    userCategories: state => state.userCategories,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
  },
  mutations: {
    setUserCategories(state, userCategories) {
      state.userCategories = userCategories;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/user-category-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'user-category-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'user-category-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchAll({ commit, dispatch, state }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        const userCategories = await axios.get('api/user-categories' + (queryString || ''));
        commit('setUserCategories', userCategories);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/user-categories/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/user-categories', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/user-categories', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/user-categories/${id}`);
    },
  },
};
